{
    "MaxfilterlistlimitLabel": "Limite maximale de la liste de filtres :",
    "MaxreportrowdisplimitLabel": "Limite maximale d'affichage des lignes du rapport :",
    "MaxfilterlistlimitPlaceholder": "150",
    "MaxreportrowdisplimitPlaceholder": "150",
    "ContentRestriction_SectionHeader": "Restriction du contenu",
    "ContentRestriction_SectionPara": "Pour les environnements comportant un grand nombre d'appareils et\/ou d'agents, vous pouvez augmenter le nombre maximal de ",
    "NAME": "ContentRestriction"
}